import React, { useEffect, useRef } from "react";

/**
 * BBB Accredited Business seal.
 * The BBB script hydrates the <a class="ruvtbul"> element with the interactive seal.
 * We load the script once per page, and re-invoke it on remount (SPA route changes)
 * so the seal renders reliably no matter which page it's on.
 */
export const BBBSeal = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const SRC = "https://seal-southerncolorado.bbb.org/inc/legacy.js";
    // If script already loaded, BBB exposes window.showsealClicks — poke the
    // seal so it re-scans and rebuilds on new anchor tags.
    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (existing) {
      // Try re-invoke if BBB exposes a global (it does on most seals)
      if (typeof window.showsealClicks === "function") {
        try { window.showsealClicks(); } catch { /* ignore */ }
      }
      return;
    }
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <a
      ref={ref}
      href="https://www.bbb.org/us/co/colorado-springs/profile/pressure-washing/all-day-power-washing-0785-1000032094/#sealclick"
      id="bbblink"
      className={`ruvtbul inline-block ${className}`}
      target="_blank"
      rel="nofollow noopener noreferrer"
      data-testid="bbb-seal"
      aria-label="BBB Accredited Business — All Day Power Washing"
    >
      <img
        src="https://seal-southerncolorado.bbb.org/logo/ruvtbul/bbb-1000032094.png"
        alt="All Day Power Washing BBB Business Review"
        style={{ border: 0 }}
        width="120"
        loading="lazy"
      />
    </a>
  );
};
